import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    ExternalLink,
    ChevronRight,
    Globe,
    Building2,
    Scale,
    Network,
    Sparkles
} from 'lucide-react';

const Tautan = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const links = [
        {
            id: 1,
            name: "Pemerintah Kota Magelang",
            url: "https://www.magelangkota.go.id/",
            logo: "https://bo.jdih.magelangkota.go.id/logo.png",
            description: "Portal Resmi Pemerintah Kota Magelang",
            icon: Building2
        },
        {
            id: 2,
            name: "Sistem Informasi Bagian Hukum",
            url: "https://siabah.magelangkota.go.id/",
            logo: "https://siabah.magelangkota.go.id/assets/2024/images/logoedit3.png",
            description: "SIABAH Magelang Kota",
            icon: Scale
        },
        {
            id: 3,
            name: "JDIH Nasional",
            url: "https://jdihn.go.id/",
            logo: "https://bo.jdih.magelangkota.go.id/media/jdihn.png",
            description: "Jaringan Dokumentasi & Informasi Hukum Nasional",
            icon: Globe
        },
        {
            id: 4,
            name: "JDIH Provinsi Jawa Tengah",
            url: "https://jdih.jatengprov.go.id/",
            logo: "https://bo.jdih.magelangkota.go.id/media/svg/logo-jawa-tengah.svg",
            description: "JDIH Provinsi Jawa Tengah",
            icon: Network
        },
        {
            id: 5,
            name: "BPHN - Kemenkumham RI",
            url: "https://bphn.go.id/",
            logo: "https://bo.jdih.magelangkota.go.id/media/bphn.png",
            description: "Badan Pembinaan Hukum Nasional",
            icon: Scale
        }
    ];

    return (
        <div className="w-full bg-gradient-to-br from-blue-50 via-white to-purple-50 py-16 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#0889c1]/10 to-purple-500/10 rounded-full mb-4">
                        <Sparkles className="w-4 h-4 text-[#0889c1]" />
                        <span className="text-xs font-medium text-gray-600">JDIH Kota Magelang</span>
                    </div>

                    <h1 className="text-4xl md:text-5xl font-bold mb-3" style={{ fontFamily: 'MuseoSansRounded900' }}>
                        <span className="text-[#0889c1]">Tautan</span>
                        <span className="text-gray-700"> Terkait</span>
                    </h1>

                    <div className="w-24 h-1 bg-gradient-to-r from-[#0889c1] to-purple-500 mx-auto rounded-full"></div>

                    <p className="mt-4 text-gray-600 text-sm md:text-base max-w-2xl mx-auto">
                        Akses cepat ke berbagai situs terkait JDIH Kota Magelang untuk informasi hukum dan pemerintahan
                    </p>
                </div>

                {/* Links Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
                    {links.map((link, index) => {
                        const Icon = link.icon;
                        return (
                            <a
                                key={link.id}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                            >
                                {/* Gradient Border Effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-[#0889c1] to-purple-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                                <div className="relative bg-white rounded-2xl m-[2px] p-6 flex flex-col items-center h-full">
                                    {/* Icon Badge */}
                                    <div className="absolute top-3 right-3 bg-gradient-to-r from-[#0889c1]/10 to-purple-500/10 p-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        <ExternalLink className="w-3.5 h-3.5 text-[#0889c1]" />
                                    </div>

                                    {/* Logo Container */}
                                    <div className="relative w-full h-32 flex items-center justify-center mb-4 bg-gradient-to-br from-gray-50 to-blue-50/50 rounded-xl p-4 group-hover:from-blue-50 group-hover:to-purple-50 transition-all duration-300">
                                        <img
                                            src={link.logo}
                                            alt={link.name}
                                            className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-110"
                                            loading="lazy"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect width="100" height="100" fill="%23e5e7eb"/%3E%3Ctext x="50" y="55" font-family="Arial" font-size="12" fill="%236b7280" text-anchor="middle"%3ENo Logo%3C/text%3E%3C/svg%3E`;
                                            }}
                                        />

                                        {/* Hover Overlay Icon */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                                            <div className="bg-white/90 rounded-full p-3 transform scale-0 group-hover:scale-100 transition-transform duration-300">
                                                <Icon className="w-6 h-6 text-[#0889c1]" />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="text-center flex-1 flex flex-col">
                                        <h3 className="text-sm font-bold text-gray-800 group-hover:text-[#0889c1] transition-colors duration-200 leading-tight">
                                            {link.name}
                                        </h3>

                                        {link.description && (
                                            <p className="text-xs text-gray-500 mt-1 group-hover:text-gray-600 transition-colors duration-200">
                                                {link.description}
                                            </p>
                                        )}

                                        {/* Visit Link Button */}
                                        <div className="mt-3 flex items-center justify-center text-[#0889c1] text-xs font-semibold opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                                            <span>Kunjungi</span>
                                            <ChevronRight className="w-3.5 h-3.5 ml-1 transform group-hover:translate-x-1 transition-transform duration-200" />
                                        </div>
                                    </div>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Tautan;